/* eslint-disable */
import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { MdEdit, MdOutlineSupportAgent, MdHome, MdPerson } from "react-icons/md";
import { PiUserList } from "react-icons/pi";
import { BsPersonPlus } from "react-icons/bs";
import { LiaCogSolid } from "react-icons/lia";
import { ProfileContext } from "context/ProfileContext";
import { TiFlowChildren } from "react-icons/ti";
import { IoLanguageSharp } from "react-icons/io5";
import { MdHourglassTop } from "react-icons/md";
import { isPendingVendorSession } from "utils/session";

// chakra imports

export function SidebarLinks(props) {
  const profileData = useContext(ProfileContext);
  // Chakra color mode
  let location = useLocation();
  const storedUser = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const dashboardUserId = profileData?.user_id || storedUser?.user_id || "";

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routePath) => {
    return Boolean(routePath) && location.pathname === `/admin/${routePath}`;
  };

  const isAdmin = sessionStorage.getItem("isAdmin");
  const isPendingVendor = isAdmin !== "true" && isPendingVendorSession(storedUser);

  // Add static routes
  const dashboardRoute = [];

  if (isPendingVendor) {
    dashboardRoute.push(
      {
        name: "Pending Approval",
        layout: "/admin",
        path: "pending-approval",
        icon: <MdHourglassTop />,
      },
      {
        name: "Profile",
        layout: "/admin",
        path: "profile",
        icon: <MdPerson />,
      },
      {
        name: "Settings",
        layout: "/admin",
        path: "settings",
        icon: <LiaCogSolid />,
      }
    );
  } else if (isAdmin !== "true") {
    dashboardRoute.push(
      {
        name: "Dashboard",
        layout: "/admin",
        path: dashboardUserId,
        icon: <MdHome className="h-6 w-6" />,
        secondary: true,
      },
      {
        name: "Help",
        layout: "/admin",
        path: "help",
        icon: <MdOutlineSupportAgent />,
      },
      {
        name: "Customize Message",
        layout: "/admin",
        path: "customize-message",
        icon: <MdEdit />,
      },
      {
        name: "Chatbot Users",
        layout: "/admin",
        path: "chatbot-users",
        icon: <PiUserList />,
      },
      {
        name: "Profile",
        layout: "/admin",
        path: "profile",
        icon: <MdPerson />,
      },
      {
        name: "Settings",
        layout: "/admin",
        path: "settings",
        icon: <LiaCogSolid />,
      }
    );
  }
  // Conditionally add the 'Vendor' route if isAdmin is true
  if (isAdmin === "true") {
    dashboardRoute.push(
      {
        name: "Vendor",
        layout: "/admin",
        path: "vendor",
        icon: <PiUserList />,
      },
      {
        name: "Vendor Onboarding",
        layout: "/admin",
        path: "vendor-onboarding",
        icon: <BsPersonPlus />,
      },
      {
        name: "Chatbot Users",
        layout: "/admin",
        path: "chatbot-users",
        icon: <PiUserList />,
      },
      {
        name: "Applicable Flow",
        layout: "/admin",
        path: "applicable-flow",
        icon: <TiFlowChildren />,
      },

      {
        name: "Language",
        layout: "/admin",
        path: "languages",
        icon: <IoLanguageSharp />,
      }
    );
  }

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.layout === "/admin" || route.layout === "/auth" || route.layout === "/rtl") {
        return (
          <Link key={index} to={`${route.layout}/${route.path}`}>
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li className="my-[3px] flex cursor-pointer items-center px-8" key={index}>
                <span
                  className={`${
                    activeRoute(route.path) === true
                      ? "w-SS font-bold text-brand-500 dark:text-white"
                      : "w-SS font-medium text-gray-600"
                  }`}
                >
                  {route.icon}
                </span>
                <p
                  className={`leading-1 ml-4 flex ${
                    activeRoute(route.path) === true
                      ? "w-SS font-bold text-navy-700 dark:text-white"
                      : "w-SS font-medium text-gray-600"
                  }`}
                >
                  {route.name}
                </p>
              </li>
              {activeRoute(route.path) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
              ) : null}
            </div>
          </Link>
        );
      }
    });
  };
  // BRAND
  return createLinks(dashboardRoute);
}

export default SidebarLinks;
